export default __webpack_public_path__ + "static/media/announcement_5@3x.cc031aa0.png";